'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _apply = require('babel-runtime/core-js/reflect/apply');

var _apply2 = _interopRequireDefault(_apply);

exports.default = trackEventMethodDecorator;

var _makeClassMemberDecorator = require('./makeClassMemberDecorator');

var _makeClassMemberDecorator2 = _interopRequireDefault(_makeClassMemberDecorator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function trackEventMethodDecorator() {
  var trackingData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return (0, _makeClassMemberDecorator2.default)(function (decoratedFn) {
    return function decorateClassMember() {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var trackEvent = function trackEvent() {
        for (var _len2 = arguments.length, promiseArguments = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          promiseArguments[_key2] = arguments[_key2];
        }

        if (_this.props && _this.props.tracking && typeof _this.props.tracking.trackEvent === 'function') {
          var thisTrackingData = typeof trackingData === 'function' ? trackingData(_this.props, _this.state, args, promiseArguments) : trackingData;
          _this.props.tracking.trackEvent(thisTrackingData);
        }
      };

      var fn = (0, _apply2.default)(decoratedFn, this, args);
      if (_promise2.default && _promise2.default.resolve(fn) === fn) {
        return fn.then(trackEvent.bind(this)).catch(function (error) {
          trackEvent(null, error);
          throw error;
        });
      }
      trackEvent();
      return fn;
    };
  });
}


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/react-tracking/build/trackEventMethodDecorator.js
// module id = CUPP
// module chunks = 19